export const SEO_DEFAULT_TITLE = "Ben Joffe";
export const SEO_DEFAULT_DESCRIPTION = "I'm a Sydney based software developer. This site is for hosting some small (mostly old) projects and notes.";
export const SEO_DEFAULT_SITE_NAME = "Ben Joffe";
export const SITE_URL = "https://www.benjoffe.com";